import { ReactNode, useLayoutEffect } from 'react';
import { useAuth, useLoginWithRedirect } from '@frontegg/react';
import Loading from '../Loading';
import useRedirectAfterLogin from '../../hooks/useRedirectAfterLogin';

type RequireAuthProps = {
  children: ReactNode;
  onAuthenticated?: (accessToken: string) => void;
};

const RequireAuth = ({
  children,
  onAuthenticated,
}: RequireAuthProps): JSX.Element => {
  const loginWithRedirect = useLoginWithRedirect();
  const { user, isAuthenticated, isLoading } = useAuth();
  const { setRedirectAfterLogin, redirectAfterLogin } = useRedirectAfterLogin();

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      setRedirectAfterLogin();
      loginWithRedirect();
    } else {
      redirectAfterLogin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, loginWithRedirect]);

  useLayoutEffect(() => {
    if (isAuthenticated && user?.accessToken && onAuthenticated) {
      onAuthenticated(user.accessToken);
    }
  }, [isAuthenticated, user?.accessToken, onAuthenticated]);

  if (isLoading || !isAuthenticated || !user) {
    return <Loading />;
  }

  return children as JSX.Element;
};

export default RequireAuth;
